// import React from 'react';
// import './trusted_brands.css';

// // Import logo images
// import toyotaLogo from '../../img/des_sec/Component 1.svg';
// import toiLogo from '../../img/des_sec/brand_2.svg';
// import altisourceLogo from '../../img/des_sec/brand_3.svg';
// import qnbLogo from '../../img/des_sec/brand_4.svg';
// import anchorLogo from '../../img/des_sec/brand_5.svg';
// import hinduLogo from '../../img/des_sec/brand_6.svg';
// import jcbLogo from '../../img/des_sec/Component 4.svg';

// const TrustedBrands = () => {
//   // Duplicate logos array for seamless looping
//   const logos = [
//     { src: toyotaLogo, alt: 'Toyota' },
//     { src: toiLogo, alt: 'TOI' },
//     { src: altisourceLogo, alt: 'Altisource' },
//     { src: qnbLogo, alt: 'QNB' },
//     { src: anchorLogo, alt: 'Anchor' },
//     { src: hinduLogo, alt: 'Hindustan Unilever Limited' },
//     { src: jcbLogo, alt: 'JCB' },
//   ];
  
//   return (
//     <div className="trusted-brands-container">
//       <h2 className="trusted-brands-heading">
//         <span className="trusted-by">Trusted by</span> 
//         <span className="leading-brands">Leading Brands</span>
//       </h2>
      
//       <div className="marquee-container">
//         <div className="marquee">
//           {/* First set of logos */}
//           {logos.map((logo, index) => (
//             <div className="logo-item" key={`logo-1-${index}`}>
//               <img src={logo.src} alt={logo.alt} className="logo-image" />
//             </div>
//           ))}
          
//           {/* Duplicated set of logos for seamless looping */}
//           {logos.map((logo, index) => (
//             <div className="logo-item" key={`logo-2-${index}`}>
//               <img src={logo.src} alt={logo.alt} className="logo-image" />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default TrustedBrands;

import React, { useRef, useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import './trusted_brands.css';

// Import logo images
import toyotaLogo from '../../img/des_sec/Component 1.svg';
import toiLogo from '../../img/des_sec/brand_2.svg';
import altisourceLogo from '../../img/des_sec/brand_3.svg';
import qnbLogo from '../../img/des_sec/brand_4.svg';
import anchorLogo from '../../img/des_sec/brand_5.svg';
import hinduLogo from '../../img/des_sec/brand_6.svg';
import jcbLogo from '../../img/des_sec/Component 4.svg';

const TrustedBrands = () => {
  const [inView, setInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
        } else {
          setInView(false);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '-50px 0px'
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, []);

  // Duplicate logos array for seamless looping
  const logos = [
    { src: toyotaLogo, alt: 'Toyota' },
    { src: toiLogo, alt: 'TOI' },
    { src: altisourceLogo, alt: 'Altisource' },
    { src: qnbLogo, alt: 'QNB' },
    { src: anchorLogo, alt: 'Anchor' },
    { src: hinduLogo, alt: 'Hindustan Unilever Limited' },
    { src: jcbLogo, alt: 'JCB' },
  ];

  // Animation for heading
  const headingAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px)' : 'translateY(30px)',
    config: { 
      tension: 200, 
      friction: 40,
      mass: 1
    },
    delay: inView ? 100 : 0
  });

  // Animation for "Trusted by" text
  const trustedByAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px)' : 'translateX(-20px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 200 : 0
  });

  // Animation for "Leading Brands" text
  const leadingBrandsAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateX(0px)' : 'translateX(20px)',
    config: { 
      tension: 180, 
      friction: 35,
      mass: 1
    },
    delay: inView ? 350 : 0
  });

  // Animation for marquee container
  const marqueeAnimation = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0px) scale(1)' : 'translateY(20px) scale(0.98)',
    config: { 
      tension: 160, 
      friction: 30,
      mass: 1
    },
    delay: inView ? 500 : 0
  });
  
  return (
    <div className="trusted-brands-container" ref={containerRef}>
      <animated.h2 
        className="trusted-brands-heading"
        style={headingAnimation}
      >
        <animated.span 
          className="trusted-by"
          style={trustedByAnimation}
        >
          Trusted by
        </animated.span> 
        <animated.span 
          className="leading-brands"
          style={leadingBrandsAnimation}
        >
          Leading Brands
        </animated.span>
      </animated.h2>
      
      <animated.div 
        className="marquee-container"
        style={marqueeAnimation}
      >
        <div className="marquee">
          {/* First set of logos */}
          {logos.map((logo, index) => (
            <div className="logo-item" key={`logo-1-${index}`}>
              <img src={logo.src} alt={logo.alt} className="logo-image" />
            </div>
          ))}
          
          {/* Duplicated set of logos for seamless looping */}
          {logos.map((logo, index) => (
            <div className="logo-item" key={`logo-2-${index}`}>
              <img src={logo.src} alt={logo.alt} className="logo-image" />
            </div>
          ))}
        </div>
      </animated.div>
    </div>
  );
};

export default TrustedBrands;